<div class="logos-container" [ngSwitch]="activeLanguage$ | ngrxPush">
    <ng-container *ngSwitchCase="'en'">
        <img
            ngSrc="/assets/images/kpo/kpo_logo_en.png"
            [alt]="'dtmMainPageLib.subpage.kpo.logos.kpoLogoAltText' | transloco"
            height="88"
            width="260"
        />
        <img
            ngSrc="/assets/images/kpo/rp_logo_en.png"
            [alt]="'dtmMainPageLib.subpage.kpo.logos.rpLogoAltText' | transloco"
            height="88"
            width="260"
        />
        <img
            ngSrc="/assets/images/kpo/eu_logo_en.png"
            [alt]="'dtmMainPageLib.subpage.kpo.logos.euLogoAltText' | transloco"
            height="88"
            width="260"
        />
    </ng-container>
    <ng-container *ngSwitchDefault>
        <img
            ngSrc="/assets/images/kpo/kpo_logo_pl.png"
            [alt]="'dtmMainPageLib.subpage.kpo.logos.kpoLogoAltText' | transloco"
            height="88"
            width="260"
        />
        <img
            ngSrc="/assets/images/kpo/rp_logo_pl.png"
            [alt]="'dtmMainPageLib.subpage.kpo.logos.rpLogoAltText' | transloco"
            height="88"
            width="260"
        />
        <img
            ngSrc="/assets/images/kpo/eu_logo_pl.png"
            [alt]="'dtmMainPageLib.subpage.kpo.logos.euLogoAltText' | transloco"
            height="88"
            width="260"
        />
    </ng-container>
</div>
